import { Component, Inject, OnInit, ViewContainerRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CDSMask } from '@app/utils/cds-mask';

import { MovimentacaoLancamento, LancamentoPesquisa } from '../lancamento.model';
import { UtilitarioService } from '@app/services/utilitario.service';
import { LancamentoService } from '@app/services/lancamento.service';
import { ConsultasService } from '@app/services/consultas.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ReceberService } from '@app/services/receber.service';
import { ToastrService } from 'ngx-toastr';
import { PagarService } from '@app/services/pagar.service';

import { UsuarioTipoService } from '@app/services/usuario-tipo.service';
import { ParticipanteService } from '@app/services/participante.service';

@Component({
  selector: 'app-lancamento-lista',
  templateUrl: 'lancamento-lista.component.html',
  styleUrls: ['./lancamento-lista.component.scss']
})
export class LancamentoListaComponent implements OnInit {

  bsModalRef: BsModalRef;

  lstMovimentacaoLancamento: MovimentacaoLancamento[] = [];
  cdsMask: CDSMask = new CDSMask();
  saldoTotal: number;
  lstContas: IdDescricao[] = [];
  lstUnidades: IdDescricao[] = [];
  pesquisa: LancamentoPesquisa = new LancamentoPesquisa();
  pesquisando: boolean;

  acessoOutrasUnidades: boolean;
  acessoTransferencia: boolean;

  movimentarTodosOsCaixas: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private movimentacaoService: LancamentoService,
    private consultaService: ConsultasService,
    private modalService: BsModalService,
    private receberService: ReceberService,
    private pagarService: PagarService,
    @Inject(ToastrService) public toastr: ToastrService,
    private usuarioTipoService: UsuarioTipoService,
    private participanteService: ParticipanteService
  ) {

  }

  ngOnInit() {
    this.consultaService.consultar('UNIDADE_S_RATEIO').subscribe(data => this.lstUnidades = data);
    this.pesquisa.DataInicial = UtilitarioService.retornaDataAtualMaisDiasISO(0);
    this.pesquisa.DataFinal = UtilitarioService.retornaDataAtualMaisDiasISO(0);
    this.pesquisa.ContaId = 0;
    this.pesquisa.UnidadeId = Number(UtilitarioService.retornaUnidadeUsuario());

    this.route.params.subscribe(
      (params: any) => {
        const id = params['contaid'];
        const data = params['data'];
        if (id) {
          this.pesquisa.ContaId = parseInt(id);
        }
        if (data) {
          this.pesquisa.DataInicial = data;
          this.pesquisa.DataFinal = data;
        }
      })

    this.participanteService.verificaPermissaoUsuario(0, 'MovimentarTodosOsCaixas')
      .subscribe(data => {
        this.movimentarTodosOsCaixas = data;
        this.consultaService.consultar('CONTA').subscribe((data) => {
          this.lstContas = data;
          this.obterTodos();
        });
      },
      () => {
        this.consultaService.consultar('CONTA_USUARIO').subscribe((data) => {
          this.lstContas = data;
          this.pesquisa.ContaId = this.lstContas[0].Id;
          this.obterTodos();
        })
      }
    );

    this.usuarioTipoService.verificaPermissaoUsuario().subscribe(
      (permissoes: any) =>{
        this.acessoOutrasUnidades = permissoes.find(x => x.Descricao == 'VisualizarOutrasUnidades').Selecionado;
        this.acessoTransferencia = permissoes.find(x => x.Descricao == 'Transferencia').Selecionado;
      })
  }

  obterTodos() {

    this.pesquisando = true;
    this.movimentacaoService.obterLancamentos(this.pesquisa)
      .toPromise().then(data => {
        if (data != null) {
          this.lstMovimentacaoLancamento = data;
          if (this.lstMovimentacaoLancamento.length > 0) {
            this.saldoTotal = this.lstMovimentacaoLancamento[this.lstMovimentacaoLancamento.length - 1].Saldo;
          } else {
            this.saldoTotal = 0;
          }

        }
        this.pesquisando = false;
      }, erro => {
        this.pesquisando = false
        this.toastr.warning("Realize a pesquisa novamente.")
      });
    //  () => this.pesquisando = false);
  }

  deletar(lancamento: MovimentacaoLancamento) {
    const config = {
      keyboard: false,
      ignoreBackdropClick: true
    };
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent, config);

    if (!lancamento.Historico) {
      lancamento.Historico = '';
    }

    this.bsModalRef.content.mensagem = 'Deseja realmente estornar a movimentação? <br><br>' + lancamento.Historico + '<br> Valor: R$ ' + lancamento.Valor;
    this.bsModalRef.content.autoHide = false;
    this.bsModalRef.content.confirmar = () => {
      this.movimentacaoService.deletar(lancamento.Id).toPromise().then((data) => {
        this.toastr.success('Estorno realizado com sucesso!');
        this.obterTodos();
        this.bsModalRef.content.hide();
      });
    };
  }

  estornoReceber(lancamento: MovimentacaoLancamento) {
    const config = {
      keyboard: false,
      ignoreBackdropClick: true
    };
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent, config);

    if (!lancamento.Historico) {
      lancamento.Historico = '';
    }

    this.bsModalRef.content.mensagem = 'Deseja realmente estornar a movimentação? <br><br>' + lancamento.Historico + '<br> Valor: R$ ' + lancamento.Valor;
    this.bsModalRef.content.autoHide = false;
    this.bsModalRef.content.confirmar = () => {
      this.estornoReceberConfirmar(lancamento.ReceberId, this.bsModalRef);
    };
  }

  estornoReceberConfirmar(receberId: number, bsModalRef: any) {
    this.receberService.realizarEstorno(receberId)
      .toPromise().then(
        () => {
          this.toastr.success('Estorno realizado com sucesso!');
          this.obterTodos();
          bsModalRef.content.hide();
        },
        (data: any) => {
          if (data.error) {
            let _erros = '';
            for (let i = 0; i < data.errors.length; i++) {
              _erros = data.errors[i] + ' ';
            }
            this.toastr.error(_erros);
          }
        }
      );
  }

  estornoPagar(lancamento: MovimentacaoLancamento) {
    const config = {
      keyboard: false,
      ignoreBackdropClick: true
    };
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent, config);

    if (!lancamento.Historico) {
      lancamento.Historico = '';
    }

    this.bsModalRef.content.mensagem = 'Deseja realmente estornar a movimentação? <br><br>' + lancamento.Historico + ' <br>Valor: R$ ' + lancamento.Valor;
    this.bsModalRef.content.autoHide = false;
    this.bsModalRef.content.confirmar = () => {
      this.estornoPagarConfirmar(lancamento.PagarId, this.bsModalRef);
    };
  }

  estornoPagarConfirmar(pagarId: number, bsModalRef: any) {
    this.pagarService.realizarEstorno(pagarId)
      .toPromise().then(
        () => {
          this.toastr.success('Estorno realizado com sucesso!');
          this.obterTodos();
          bsModalRef.content.hide();
        },
        (erro: any) => {
          if (erro.error) {
            let _erros = '';
            for (let i = 0; i < erro.error.errors.length; i++) {
              _erros = erro.error.errors[i] + ' ';
              this.toastr.error(_erros);
            }
          }
        }
      );
  }
}



